import React from 'react'
import './Logo.scss'

const Logo = (props) => {
  return (
    <div className='logo'>
      <em className='daptiv-logo size-default vertical-center' />
    </div>
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Header/Logo.js